























import { Component, Vue, Prop } from "vue-property-decorator";
import Popup from "@/components/default/Popup.vue";

@Component({
  components: {
    Popup,
  },
})
export default class MeasuringStateApprovedPopup extends Vue {
  show: boolean = false;
  saving: boolean = false;

  public open() {
    this.show = true;
  }

  save() {
    this.$emit("approveMeasuringState", true);
    this.show = false;
  }

  closed() {
    this.$emit("approveMeasuringState", false);
    this.show = false;
  }
}
